import React, { useEffect } from 'react';
import { Select2 } from '@economic/taco';
import { FormApi } from 'final-form';
import { BankDto } from '~/types/internal-api';
import useCachedQuery from '~/app/shared/hooks/useCachedQuery';

interface Props {
    value: string;
    form: FormApi<Record<string, any>, Partial<Record<string, any>>>;
}

export const BankDropdown = ({ form, value, ...props }: Props) => {
    const { loading, data: banks } = useCachedQuery<BankDto[]>(`/smartbank/banks-collection`, []);

    useEffect(() => {
        if (value && banks.length) {
            const { batch, change } = form;

            const bank = banks.find(item => item.name === value);

            if (!bank) {
                return;
            }

            const { swift, formatNumber: number } = bank;

            batch(() => {
                change('bic', swift);
                change('format', { number });
            });
        }
    }, [value, loading]);

    return (
        <Select2 className="w-20" value={value} {...props}>
            {banks.map(item => (
                <Select2.Option key={item.name} value={item.name}>
                    {item.name}
                </Select2.Option>
            ))}
        </Select2>
    );
};
